import React from 'react';
import { Card } from '../components/UI/Card';
import { Button } from '../components/UI/Button';
import { Link } from 'react-router-dom';
interface FAQProps {
  openRegistrationForm?: () => void;
}
export const FAQ = ({
  openRegistrationForm
}: FAQProps) => {
  const faqSections = [{
    title: '🌍 For Visitors',
    questions: [{
      question: 'What is The Networking Salon?',
      answer: 'The Networking Salon is a community designed for culture shapers, leaders, influencers, and professionals who want to grow, collaborate, and make meaningful connections. We provide resources, curated opportunities, and interactive spaces to build authentic networks.'
    }, {
      question: 'Who can join the community?',
      answer: "Our community is open to professionals, entrepreneurs, creatives, and leaders who are curious, impact-driven, and ready to collaborate. Whether you're just starting out or already established, you'll find tools, peers, and opportunities to grow."
    }, {
      question: 'Is the community free to join?',
      answer: "No. The Networking Salon is a curated membership community. Interested individuals must apply to join. If approved, you'll receive details regarding membership plans and payment.",
      hasButton: true
    }, {
      question: 'What is the membership application process?',
      answer: <div data-id="element-2967" data-mp="24fbbo0pa5md7">
              <p data-id="element-2968" data-mp="24bni51ju4zyh">The process is simple:</p>
              <ul className="list-disc list-inside mt-2 space-y-1" data-id="element-2969" data-mp="29dwca18g2826">
                <li data-id="element-2970" data-mp="2deomawp54gzi">
                  <strong data-id="element-2971" data-mp="2ddwqplvjmj98">Apply</strong> → Submit an application form.
                </li>
                <li data-id="element-2972" data-mp="2i4wn8q0r2zb7">
                  <strong data-id="element-2973" data-mp="2i6g5gm5yvkfm">Review</strong> → Our team evaluates your fit with the
                  community's vision.
                </li>
                <li data-id="element-2974" data-mp="2n6lz27vsrh0c">
                  <strong data-id="element-2975" data-mp="2s3kv4vz0ty16">Approval</strong> → If approved, you'll receive
                  membership details.
                </li>
                <li data-id="element-2976" data-mp="2x1vzir6jrgc0">
                  <strong data-id="element-2977" data-mp="2x375mxngt06a">Payment</strong> → Secure your spot by completing
                  payment.
                </li>
                <li data-id="element-2978" data-mp="27cfla89tlidz">
                  <strong data-id="element-2979" data-mp="22fgtvxhjjpjh">Onboarding</strong> → Get access to resources, the
                  directory, and events.
                </li>
              </ul>
            </div>,
      hasButton: true
    }, {
      question: 'What kind of resources do you offer?',
      answer: <div data-id="element-2980" data-mp="2ccboi5ap15sh">
              <p data-id="element-2981" data-mp="2cbs5el9b4bcv">We've built practical, ready-to-use resources, including:</p>
              <ul className="list-disc list-inside mt-2 space-y-1" data-id="element-2982" data-mp="2q3gj2sz7f7vy">
                <li data-id="element-2983" data-mp="2l6q468z4yic4">
                  🚀 LinkedIn Optimization Checklist – strengthen your
                  professional visibility.
                </li>
                <li data-id="element-2984" data-mp="300uw0ilx5eji">
                  🤝 Networking Scripts & Templates – easy outreach and
                  follow-up examples.
                </li>
                <li data-id="element-2985" data-mp="15q7swn4j22hw">
                  🌏 Opportunity Tracker – keep tabs on grants, fellowships, and
                  funding.
                </li>
                <li data-id="element-2986" data-mp="3cdghxnltxtky">
                  🎙 Podcast Starter List – curated content to sharpen skills
                  and mindset.
                </li>
                <li data-id="element-2987" data-mp="3hb89ggikbdom">
                  ❤️ Community Culture Tools – frameworks for collaboration and
                  mentorship.
                </li>
                <li data-id="element-2988" data-mp="37mqbe71o3koo">
                  📒 Community Directory – connect with members based on skills
                  and interests.
                </li>
              </ul>
            </div>
    }]
  }, {
    title: '✨ For New Members',
    questions: [{
      question: 'How do I get started once I join?',
      answer: <ul className="list-disc list-inside space-y-1" data-id="element-2989" data-mp="2jp1619xzvrdu">
              <li data-id="element-2990" data-mp="2jqm2x67s7mev">Complete your member profile in the Community Directory.</li>
              <li data-id="element-2991" data-mp="2oonl7oxdvhpa">
                Explore the Networking Guide to design your networking approach.
              </li>
              <li data-id="element-2992" data-mp="hy7nqewmgw25">Check the Opportunity Tracker and Scholarship Database.</li>
              <li data-id="element-2993" data-mp="mv6fwrwq6sxp">
                Attend an onboarding session (virtual) to meet other new
                members.
              </li>
            </ul>
    }, {
      question: 'How do I connect with other members?',
      answer: <div data-id="element-2994" data-mp="2e1c85albec2o">
              <p data-id="element-2995" data-mp="2dyq61qh70oru">You can connect through:</p>
              <ul className="list-disc list-inside mt-2 space-y-1" data-id="element-2996" data-mp="29xwgkso3r1wu">
                <li data-id="element-2997" data-mp="2504o9xjjpds4">
                  The Community Directory (searchable by skills, interests, and
                  location).
                </li>
                <li data-id="element-2998" data-mp="202cka55mm17k">
                  Peer-to-peer Networking Sessions (scheduled via Calendly).
                </li>
                <li data-id="element-2999" data-mp="1v7yoi1n1xs2d">Collaboration Playbooks and group projects.</li>
                <li data-id="element-3000" data-mp="1qbrsb0kgjuxm">Events, both virtual and in-person.</li>
              </ul>
            </div>
    }, {
      question: "I'm new to networking. Where should I start?",
      answer: <div data-id="element-3001" data-mp="1hatig1nc8t74">
              <p data-id="element-3002" data-mp="1h98qmjserocy">
                Start with our Networking Guide — an interactive workbook that
                helps you design your own approach, build confidence, and track
                progress. Pair it with the Networking Scripts to make first
                outreach easier.
              </p>
              <div className="mt-4" data-id="element-3003" data-mp="3swc83s94wd36">
                <Link to="/networking-guide" data-id="element-3004" data-mp="3szq84tubsa7g">
                  <Button variant="outline" data-id="element-3005" data-mp="1r2pwmrdt344">View Networking Guide</Button>
                </Link>
              </div>
            </div>
    }]
  }, {
    title: '🌱 For Active Members',
    questions: [{
      question: 'How do I use the Notion templates?',
      answer: "We provide shareable Notion templates that you can duplicate into your own workspace with a single click. You'll find trackers, databases, and interactive workbooks (like the Networking Guide)."
    }, {
      question: 'Can I contribute resources to the community?',
      answer: 'Yes! We welcome member contributions — from opportunities, guides, and case studies to hosting workshops. Collaboration is at the heart of the Networking Salon.'
    }, {
      question: 'Do you host events?',
      answer: 'Yes! We organize virtual meetups, workshops, and city-based gatherings (e.g., Lagos, Abuja, Berlin, Benin City, Delta). Members can also host their own events through our collaboration framework.'
    }, {
      question: 'How do I stay updated?',
      answer: <ul className="list-disc list-inside space-y-1" data-id="element-3006" data-mp="7dycu11cvql0">
              <li data-id="element-3007" data-mp="2ev86hpafmdk">Subscribe to our community mailing list.</li>
              <li data-id="element-3008" data-mp="2hr460hks0zd">Check the Opportunity Tracker regularly.</li>
              <li data-id="element-3009" data-mp="3avzq4ppldtik">Follow updates inside the community hub.</li>
            </ul>
    }]
  }];
  return <div className="pt-20" data-id="element-3010" data-mp="35x583pzg88zi">
      <section className="py-16 bg-secondary/5" data-id="element-3011" data-mp="35xy6a2kcdq61">
        <div className="container mx-auto px-4" data-id="element-3012" data-mp="3jweejxxuroqa">
          <h1 className="text-4xl font-bold text-center text-secondary-dark mb-6" data-id="element-3013" data-mp="3jx7k4vl2s86u">
            ❓ Frequently Asked Questions (FAQ)
          </h1>
          <p className="text-center text-lg text-secondary max-w-3xl mx-auto" data-id="element-3014" data-mp="z54ewn0mzycx">
            Find answers to common questions about The Networking Salon,
            membership, and how to make the most of our community.
          </p>
        </div>
      </section>
      <section className="py-16" data-id="element-3015" data-mp="12po4o5xihj9w">
        <div className="container mx-auto px-4" data-id="element-3016" data-mp="17n7hr2ih3q09">
          <div className="space-y-12" data-id="element-3017" data-mp="17nzdcdc2lnqj">
            {faqSections.map((section, sectionIndex) => <div key={sectionIndex} data-id="element-3018" data-mp="sqp1v3zfghut" data-mpi={sectionIndex}>
                <h2 className="text-2xl font-bold text-secondary-dark mb-6" data-id="element-3019" data-mp="srrr77h3qc8m">
                  {section.title}
                </h2>
                <div className="space-y-6" data-id="element-3020" data-mp="1ldt1etfr43z7">
                  {section.questions.map((faq, faqIndex) => <Card key={faqIndex} className="p-6" data-id="element-3021" data-mp="1qdp6yx43k3gv" data-mpi={faqIndex}>
                      <h3 className="text-xl font-bold text-secondary-dark mb-3" data-id="element-3022" data-mp="1qf8o0pxkuijp">
                        {faqIndex + 1}. {faq.question}
                      </h3>
                      <div className="text-secondary" data-id="element-3023" data-mp="1gmb209tdmbgc">{faq.answer}</div>
                      {faq.hasButton && <div className="mt-4" data-id="element-3024" data-mp="24cot9y45069v">
                          <Button onClick={openRegistrationForm} data-id="element-3025" data-mp="24aub2rk92s9h">
                            Apply Now
                          </Button>
                        </div>}
                    </Card>)}
                </div>
              </div>)}
          </div>
        </div>
      </section>
    </div>;
};